import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import React from 'react';
import colors from '@/styles/colors';
import RenderDrawerItem from './RenderDrawerItem';
import { StyledBoxContainer, StyledDrawer } from './styles';

export default function RenderDrawer() {
  const drawerWidth = 260;
  const container = window !== undefined ? () => window.document.body : undefined;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleLinkClick = (id) => {
    const ele = document.getElementById(id);
    const clickedEle = document.getElementById(`link_${id}`);
    const activeEle = document.querySelector('.MuiListItem-button, .Mui-Focused');
    if (activeEle) {
      activeEle.classList.remove('Mui-Focused');
      clickedEle.classList.add('.Mui-Focused');
    } else {
      clickedEle.classList.add('.Mui-Focused');
    }
    if (ele) {
      ele.scrollIntoView({ behavior: 'auto', block: 'start', inline: 'center' });
    }
  };
  return (
    <StyledBoxContainer component="nav" sx={{ width: { lg: drawerWidth }, flexShrink: { sm: 0 } }} aria-label="mailbox folders">
      <AppBar
        position="fixed"
        sx={{
          width: { md: '100%' },
          display: { lg: 'none' },
          background: colors.header,
        }}
      >
        <Toolbar variant="dense">
          <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={handleDrawerToggle} sx={{ mr: 2 }}>
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Papu Kumar
          </Typography>
        </Toolbar>
      </AppBar>
      <StyledDrawer
        container={container}
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', lg: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, backgroundColor: '#1c1427' },
        }}
      >
        <Toolbar variant="dense" />
        <RenderDrawerItem handleLinkClick={handleLinkClick} />
      </StyledDrawer>
      <StyledDrawer
        variant="permanent"
        sx={{
          display: { xs: 'none', lg: 'block' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, backgroundColor: '#1c1427' },
        }}
        open
      >
        <Toolbar variant="dense" />
        <RenderDrawerItem handleLinkClick={handleLinkClick} />
      </StyledDrawer>
    </StyledBoxContainer>
  );
}
